import React from 'react';

const LandingHero = () => {
  return (
    <div className="bg-white border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            AI Assist
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            An intelligent learning platform, powered by AI, to enhance your learning experience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingHero;

